import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import { queryJumpable } from '@gp/utils/common';
import { getRegExpInstance } from '@gp/utils/validators';
import { useDebounceFn } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Bubble, Button, Icon, Tag } from 'tea-component';

import '@gp/assets/css/pages/prejectsItems.scss';
import './index.scss';
export default function PrejectsItems(props: any) {
  const {
    domain,
    content,
    cover,
    iconText,
    contentOjb,
    contentType,
    searchKey,
    style = null,
    notImg = false,
    isShowBubble = false, // 是否要bubble气泡
    isControlledBubble = false, // bubble的展示是否受控
    isVisibleBubble = false, // 受控时控制bubble的展示
    bubbleContent,
    isReport = false,
    showRightBtn = false,
    showItemClose = false,
    rightBtnText = 'Details',
    onRightBtnClick,
    onCloseIcon,
  } = props;

  const contentRef = useRef(null);
  const textRef = useRef(null);
  const [showBubble, setShowBubble] = useState(false);

  const addColorName = useMemo(() => {
    if (!content) return '';
    if (!searchKey) return content;
    const searchKeyReg = getRegExpInstance(searchKey);
    return content.replaceAll(
      searchKeyReg,
      (matched: string) => `<span style="color: #326ff0">${matched}</span>`,
    );
  }, [searchKey, content]);

  useEffect(() => {
    if (textRef.current) {
      toggleShowBulle();
    }

    window.addEventListener('resize', toggleShowBulle);

    return () => {
      window.removeEventListener('resize', toggleShowBulle);
    };
  }, []);

  const toggleShowBulle = () => {
    const textWidth = textRef.current?.getBoundingClientRect().width;
    const contentWidth = contentRef.current?.getBoundingClientRect().width;
    return textWidth > contentWidth ? setShowBubble(true) : setShowBubble(false);
  };

  let businessOwner = contentOjb?.bo || '';
  if (businessOwner) {
    try {
      businessOwner = Object.values(JSON.parse(businessOwner))[0] || businessOwner;
    } catch (error) {
      console.warn(error);
    }
  }

  const { run: handleRightBtnClick } = useDebounceFn(
    (isJump = true) => {
      if (isJump) {
        onRightBtnClick?.();
      }

      return onRightBtnClick?.(false);
    },
    { wait: 300 },
  );

  return (
    <div className="dbg-prejects dbg-search-dropdown" style={style ? style : {}}>
      {!notImg && (
        <GeneralImageNew
          className="dbg-search-dropdown-img"
          domain={domain}
          width={34}
          height={34}
          src={cover}
        />
      )}
      <div
        className={classNames({
          'dbg-prejects-text': true,
          'dbg-prejects-text-hover': isVisibleBubble,
        })}
        style={{ marginLeft: notImg ? 0 : 10 }}
      >
        <div className="dbg-prejects-text-content" ref={contentRef}>
          {isShowBubble || showBubble ? (
            <>
              <Bubble
                dark
                // destroyOnClose={false}
                // arrowPointAtCenter={false}
                placement="top"
                visible={isControlledBubble ? isVisibleBubble : undefined}
                content={
                  <section
                    className={`${
                      isReport ? 'globalpedia-modal-font16' : 'globalpedia-modal-font14'
                    }`}
                  >
                    {contentType == 'div' ? (
                      <div>
                        <ul>
                          <li>
                            Mobile Legends: {contentOjb.mobile.text}
                            {contentOjb?.mobile?.icon ? (
                              <Tag
                                className="dbg-prejects-text-content-bubble-tag"
                                style={{ marginLeft: 4 }}
                              >
                                {contentOjb?.mobile?.icon}
                              </Tag>
                            ) : (
                              ''
                            )}
                          </li>
                        </ul>
                        <p>Studio: {contentOjb.studio || '-'}</p>
                        <p>Group: {contentOjb.form || '-'}</p>
                        <p>Priority: {contentOjb.priority || '-'}</p>
                        <p>BO: {businessOwner || '-'}</p>
                        <p>Coordinator: {contentOjb.coordinator || '-'}</p>
                      </div>
                    ) : iconText ? (
                      <div className="dbg-prejects-text-content-bubble">
                        <div style={{ color: '#FFFFFF', lineHeight: 2 }}>{content}</div>
                        <div style={{ marginLeft: 10 }}>
                          <Tag className="dbg-prejects-text-content-bubble-tag">{iconText}</Tag>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="dbg-prejects-text-content-text">
                          {bubbleContent || content}
                        </div>
                      </>
                    )}
                  </section>
                }
              >
                <span ref={textRef} className="dbg-search-dropdown-title">
                  {contentType === 'div' ? (
                    `Mobile Legends: ${contentOjb?.mobile?.text} ${contentOjb?.mobile?.icon}
                      Studio: ${contentOjb.studio || '-'}
                      Group: ${contentOjb.form || '-'}
                      Priority: ${contentOjb.priority || '-'}
                      BO: ${businessOwner || '-'}
                      Coordinator: ${contentOjb.coordinator || '-'}`
                  ) : (
                    <span
                      style={{ fontWeight: 'bold' }}
                      dangerouslySetInnerHTML={{ __html: addColorName }}
                    />
                  )}
                </span>
              </Bubble>
            </>
          ) : (
            <>
              <span ref={textRef} className="dbg-search-dropdown-title">
                {contentType === 'div' ? (
                  `Mobile Legends: ${contentOjb?.mobile?.text} ${contentOjb?.mobile?.icon}
                    Studio: ${contentOjb.studio || '-'}
                    Group: ${contentOjb.form || '-'}
                    Priority: ${contentOjb.priority || '-'}
                    BO: ${businessOwner || '-'}
                    Coordinator: ${contentOjb.coordinator || '-'}`
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: addColorName }} />
                )}
              </span>
            </>
          )}
        </div>
        <div className="dbg-prejects-text-slot">{props.children}</div>
      </div>
      <div className="dbg-search-dropdown-right">
        {showRightBtn && (
          <div className="dbg-search-dropdown-details">
            <span className="dbg-search-dropdown-details-line"></span>
            <LinkJump url={handleRightBtnClick(false)}>
              <Button
                className="dbg-search-dropdown-details-btn"
                onClick={(e) => {
                  if (!queryJumpable(e)) return;
                  e?.stopPropagation();
                  e?.preventDefault();
                  handleRightBtnClick();
                }}
              >
                <span className="dbg-search-dropdown-details-span">{rightBtnText}</span>
              </Button>
            </LinkJump>
          </div>
        )}
        {showItemClose && (
          <Icon type="dismiss" className="dbg-search-dropdown-dismiss" onClick={onCloseIcon} />
        )}
      </div>
    </div>
  );
}
